import Vue from 'vue';
export class StateWatcher {
  constructor() {
    this.v = new Vue();
    this.events = new Map();
    this.disposers = new Map();
  }
  register(event) {
    this.events.set(event.id, event);
  }
  enable(id) {
    const event = this.events.get(id);
    if (!event) return;
    const disposer = this.v.$watch(event.trigger, event.callback, event.watchOptions);
    this.disposers.set(id, disposer);
  }
  disable(id) {
    const disposer = this.disposers.get(id);
    if (!disposer) return;
    disposer();
  }
}
//# sourceMappingURL=StateWatcher.js.map
